export const DEFAULT_EYE_LED_COLOR = '#000000';

export const getEyeLedIntensity = (color: string, activeIntensity: number) => (
  /^#0{6}$/i.test(color) ? 0 : activeIntensity
);

export function getEyeLedSurfaceState(color: string) {
  if (/^#0{6}$/i.test(color)) {
    return {
      isOff: true,
      color: '#9fc6cd',
      emissive: '#000000',
      emissiveIntensity: 0,
      transparent: true,
      opacity: 0.58,
      transmission: 0.62,
      roughness: 0.06,
      depthWrite: false,
    } as const;
  }
  return {
    isOff: false,
    color,
    emissive: color,
    emissiveIntensity: 2.6,
    transparent: false,
    opacity: 1,
    transmission: 0,
    roughness: 0.08,
    depthWrite: true,
  } as const;
}